import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import UserHome from '../../pages/user/UserHome';
import AdminDashboard from '../../pages/admin/AdminDashboard';
import { ROLES } from '../../config/menuConfig';

/**
 * RoleBasedRedirect component
 * Renders different home pages based on user role
 * - USER role: Shows UserHome
 * - ADMIN role: Shows AdminDashboard
 * - SUPER_ADMIN role: Shows AdminDashboard
 * - Not authenticated: Redirects to login
 */
export default function RoleBasedRedirect() {
  const { user, isAuthenticated, isInitialized } = useSelector((state) => state.auth);

  // Wait for auth to initialize
  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  // Render based on role
  if (user?.role === ROLES.USER) {
    return <UserHome />;
  }

  if (user?.role === ROLES.ADMIN || user?.role === ROLES.SUPER_ADMIN) {
    return <AdminDashboard />;
  }

  // Default fallback - show user home
  return <UserHome />;
}
